/* eslint-disable prettier/prettier */
import React, {CSSProperties, useEffect, useState} from 'react'
import {Page} from '../../components/Page';
import {checkIsAdmin} from '../../utils/checkIsAdmin';
// import {useSnackbar} from 'notistack';
import {Button, colors, InputAdornment, Switch, TextField} from '@material-ui/core';
import Results from './Results';
import getGlobalCreditCardFee from './getGlobalCreditCardFee.api';
import updateCreditCardFee, {UpdateCreditCardFeeInput} from './updateCreditCardFee.api';
import {WcvType} from '../../graphql/logs.datatypes';
import {useSnackbar} from 'notistack';
import createCreditCardFee, {CreateCreditCardFeeInput} from './createCreditCardFee.api';
import getStates from '../States/getStates.api';
import {State} from '../../graphql/states.datatypes';
import upsertStateCreditCardFees, {UpsertStateCreditCardFeesInput} from "./upsertStateCreditCardFees.api";
import {CreditCardFee as CCFee} from "../../graphql/payments.datatypes";
import deleteCreditCardFee from "./deleteCreditCardFee.api";


const styles: { [key: string]: CSSProperties } = {
    root: {padding: '32px'},
    divider: {
        borderBottom: '1px solid lightgray',
    },
    header: {paddingBottom: '20px'},
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '30px',
        padding: '0px 32px 32px 32px',
    },
    formContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
    },
    toggleContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    input: {
        maxWidth: '250px'
    },
    saveButton: {
        color: 'white',
        backgroundColor: colors.green[600],
        width: 'fit-content',
    }
}

export default function CreditCardFee() {
    const globalCreditCardFee = getGlobalCreditCardFee();
    const [sendUpdateCreditCardFee, updateData] = updateCreditCardFee();
    const [sendCreateCreditCardFee, createData] = createCreditCardFee();
    const [sendUpsertCreditCardFee, upsertData] = upsertStateCreditCardFees();
    const [sendDeleteCreditCardFee, deleteData] = deleteCreditCardFee();
    const {enqueueSnackbar} = useSnackbar();
    const initStatesData = getStates();
    const [states, setStates] = useState<State[]>()
    const [showCreditCardFee, setShowCreditCardFee] = useState(false)
    const [creditCardFeePercentage, setCreditCardFeePercentage] = useState<string | null>('0')
    const [error, setError] = useState({
        isError: false,
        errorMessage: ''
    })
    const isAdmin = checkIsAdmin()

    function handleChangePercentage(e: React.ChangeEvent<HTMLInputElement>) {
        if (Number(e.target.value) < 0){
            setCreditCardFeePercentage('0')
            return;
        }
        if (e && !isNaN(Number(e.target.value))) {
            setCreditCardFeePercentage(e.target.value)
        }
    }

    useEffect(() => {
        if (!globalCreditCardFee.loading && globalCreditCardFee.data && globalCreditCardFee.data.globalCreditCardFee && globalCreditCardFee.data.globalCreditCardFee.fee && globalCreditCardFee.data.globalCreditCardFee.fee  !== '0') {
            setShowCreditCardFee(true)
            setCreditCardFeePercentage(globalCreditCardFee.data.globalCreditCardFee.fee)
        }
    }, [globalCreditCardFee])

    useEffect(() => {
        if (!initStatesData.loading && initStatesData.data && initStatesData.data.states) {
            // deep clone initStatesData to preserve original values
            setStates(JSON.parse(JSON.stringify(initStatesData.data.states)))
        }
    }, [initStatesData.data])

    function handleStateUpdate(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>, currentState: State) {
        if (e && !isNaN(Number(e.target.value)) && states) {
            // @ts-ignore
            const state: State = states.find(
                targetState => currentState.id === targetState.id
            );
            const fee = Number(e.target.value) < 0 ? '0' : e.target.value;
            state.credit_card_fee ?
                state.credit_card_fee = {...state.credit_card_fee, fee} :
                state.credit_card_fee = {
                    fee,
                    type: WcvType.STATE,
                    type_id: state.id,
                }
            setStates([...states]);
        }
    }

    function handleSaveCreditCardFees() {
        if (states) {
            const stateCreditCardFees: CCFee[] = states
                .map(state => state.credit_card_fee)
                .map((stateCreditCardFee) => {
                    if (stateCreditCardFee) {
                        stateCreditCardFee.fee = stateCreditCardFee.fee.toString()
                        stateCreditCardFee.__typename = undefined;
                    }
                    return stateCreditCardFee
                })
                .filter(stateCreditCardFee => stateCreditCardFee !== null);
            const data: UpsertStateCreditCardFeesInput = {
                inputs: stateCreditCardFees
            };
            sendUpsertCreditCardFee({variables: data}).then(() => {
                enqueueSnackbar('Credit Card Fees Saved.', {variant: 'success'});
            })
                .catch(() => {
                    enqueueSnackbar('Save Credit Card Fee Failed!', {variant: 'error'});
                });
        }
    }

    function handleDeleteCreditCardFee(id?: number) {
        if (id) {
            sendDeleteCreditCardFee({variables: {id}}).then(() => {
                enqueueSnackbar('Credit Card Fees Deleted.', {variant: 'success'});
            })
                .catch(() => {
                    enqueueSnackbar('Delete Credit Card Fee Failed!', {variant: 'error'});
                });
        }
    }

    const onSaveClick = () => {
        if (!globalCreditCardFee.loading && globalCreditCardFee.data) {
            const globalCreditCardFeeId = globalCreditCardFee.data.globalCreditCardFee && globalCreditCardFee.data.globalCreditCardFee.id;
            if (!globalCreditCardFeeId) {
                const data: CreateCreditCardFeeInput = {
                    data: {
                        fee: creditCardFeePercentage && creditCardFeePercentage.toString(),
                        type: WcvType.SYSTEM,
                    }
                }
                sendCreateCreditCardFee({variables: data}).then(() => {
                    enqueueSnackbar('Credit Card Fee Saved.', {variant: 'success'});
                })
                    .catch(() => {
                        enqueueSnackbar('Save Credit Card Fee Failed!', {variant: 'error'});
                    });
            } else {
                if (!showCreditCardFee) {
                    setCreditCardFeePercentage('0')
                    handleDeleteCreditCardFee(globalCreditCardFeeId)
                } else {

                    const data: UpdateCreditCardFeeInput = {
                        data: {
                            id: globalCreditCardFeeId,
                            fee: creditCardFeePercentage && creditCardFeePercentage.toString(),
                            type: WcvType.SYSTEM,
                        }
                    }
                    sendUpdateCreditCardFee({variables: data}).then(() => {
                        enqueueSnackbar('Credit Card Fee Saved.', {variant: 'success'});
                    })
                        .catch(() => {
                            enqueueSnackbar('Save Credit Card Fee Failed!', {variant: 'error'});
                        });
                }
            }
        }
    }

    return (
        <>
            <Page title="Credit Card Fee">
                <div style={styles.root}>
                    <div style={styles.divider}>
                        <h3
                            className="MuiTypography-root MuiTypography-h3"
                            style={styles.header}
                        >
                            Credit Card Fee Management
                        </h3>
                    </div>
                </div>
                <div style={styles.container}>
                    <div style={styles.toggleContainer}>
                        <Switch
                            color="secondary"
                            edge="start"
                            name="credit_card_fee_enabled"
                            onChange={() => setShowCreditCardFee(!showCreditCardFee)}
                            checked={showCreditCardFee}
                        />
                        <label
                            htmlFor="credit_card_fee_enabled"
                            className="MuiTypography-root MuiTypography-h5"
                        >
                            Credit Card Fee
                        </label>
                    </div>
                    {isAdmin && (
                        <form style={styles.formContainer}>
                            {showCreditCardFee && (
                                <TextField
                                    type="number"
                                    label="Credit Card Fee"
                                    name="credit_card_fee"
                                    helperText={error.isError && error.errorMessage}
                                    style={styles.input}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangePercentage(e)}
                                    value={creditCardFeePercentage}
                                    variant="outlined"
                                    error={error.isError}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                    }}
                                />
                            )}
                            <Button
                                color="primary"
                                style={{
                                    ...styles.saveButton,
                                    ...(error.isError ? {opacity: 0.5} : {})
                                }}
                                onClick={() => onSaveClick()}
                                variant="contained"
                                disabled={error.isError || !creditCardFeePercentage}
                            >
                                Save
                            </Button>
                        </form>
                    )}
                    {!initStatesData.loading && initStatesData.data && states &&
                        <Results states={states}
                                 initStates={initStatesData.data.states}
                                 onStateUpdate={handleStateUpdate}
                                 onSubmit={handleSaveCreditCardFees}
                                 onDelete={handleDeleteCreditCardFee}
                        />
                    }
                </div>
            </Page>
        </>
    )
}
